import { Object3D, Box3, Mesh } from "three";

/**
 * Expands the given box to include all the visible Mesh elements belonging to
 * the given object. This assumes that meshes only appear as leaf elements of
 * the passed object tree.
 */
export const visibleSize = (obj: Object3D, box: Box3, precise: boolean = true) => {
    if(obj instanceof Mesh && obj.visible) {
        box.expandByObject(obj, precise);
    } else {
        for(const child of obj.children) {
            visibleSize(child, box, precise);
        }
    }
};
export default visibleSize;
